import { List, Tooltip, Typography } from 'antd'
import CIMSDivider from 'components/CIMSDivider'
import { dateFormatter } from 'utils/dateFormatter'

export type ApprovalNote = {
  approvalGroup: string
  date: string
  disposition: string
  text: string
  userMail: string
  userName: string
}

type NotesByApprovalGroup = {
  approvalGroup: string
  notes: ApprovalNote[]
}

/**
 * Displays approval notes in the same grouped, timestamped format as RFI
 * responses, with each Approval Group acting as the group heading.
 */
export default function Notes({ notes }: { notes: ApprovalNote[] }) {
  const byApprovalGroup = notes.reduce((groups, note) => {
    const existing = groups.get(note.approvalGroup)
    if (existing) existing.notes.push(note)
    else
      groups.set(note.approvalGroup, {
        approvalGroup: note.approvalGroup,
        notes: [note],
      })
    return groups
  }, new Map<string, NotesByApprovalGroup>())

  return (
    <List
      dataSource={[...byApprovalGroup.values()].sort(
        ({ approvalGroup: a }, { approvalGroup: b }) => a.localeCompare(b)
      )}
      renderItem={({ approvalGroup, notes }) => (
        <>
          <CIMSDivider>
            <Typography.Text strong>{approvalGroup}</Typography.Text>
          </CIMSDivider>
          {notes.map(
            ({ date, disposition, text, userMail, userName }, index) => (
              <div key={`${approvalGroup}-${date}-${userMail}-${index}`}>
                <Tooltip title={userName ? userMail : ''}>
                  <Typography
                    style={{
                      display: 'inline-block',
                      marginTop: index > 0 ? 5 : 0,
                    }}
                  >
                    {`[${dateFormatter.shortDatetime(date)}] (${disposition}) ${
                      userName ?? userMail
                    }:`}
                  </Typography>
                </Tooltip>
                <Typography>{text}</Typography>
              </div>
            )
          )}
        </>
      )}
      style={{ maxWidth: 725 }}
    />
  )
}
